import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import AddBookList from "../AddBookList/AddBookList";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class BookListBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      bookId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (bookId) => {
    this.setState({
      editStatus: true,
      bookId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (bookId) => {
    this.setState({
      dialogOpen: true,
      bookId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteBook = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/books/${this.state.bookId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Book deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getBookList();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteBook();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow>
        <TableCell align="center" style={{ padding: 0 }}>
          {index + 1}
        </TableCell>
        <TableCell align="center">{data.title}</TableCell>
        <TableCell align="center">{data.numberOfCopies}</TableCell>
        <TableCell align="center">{data.currentStock}</TableCell>
        <TableCell align="center">{data.ISBN}</TableCell>
        <TableCell align="center">{data.author}</TableCell>
        <TableCell align="center">
          {data.category ? data.category : "N/A"}
        </TableCell>
        <TableCell align="center">
          {data.publication ? data.publication : "N/A"}
        </TableCell>

        <TableCell align="center">
          <Tooltip
            title="Info"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/library/details/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEdit(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteBook}
        />
      </TableRow>
    ) : (
      <AddBookList
        editStatus={true}
        data={data}
        bookId={this.state.bookId}
        getBookList={this.props.getBookList}
        handleCancelEdit={this.handleCancelEdit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(BookListBody)));
